import React, { Component } from 'react';
import L from 'leaflet';
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png'
import iconUrl from 'leaflet/dist/images/marker-icon.png'
import shadowUrl from 'leaflet/dist/images/marker-shadow.png'
import leafletAwesomeMarker from '../lib/leaflet.awesome-markers.js';

export class MapCreatorPanel extends Component {

    constructor(props) {
      super(props);

    }


    addStartMarkerToMap = (route) => {

      var greenMarker = L.AwesomeMarkers.icon({
        icon: 'arrow-up',
        prefix: 'fa',
        markerColor: 'green',
        //iconAnchor: [10, 40]
      });

      route.from.marker = L.marker([route.from.lat, route.from.lng], {icon: greenMarker})
      .bindTooltip(this.getStartMarkerTooltip(route), {})
      .addTo(this.map);
    }

    addEndMarkerToMap = (route) => {

      var redMarker = L.AwesomeMarkers.icon({
        icon: 'arrow-down',
        prefix: 'fa',
        markerColor: 'red',
        //iconAnchor: [10, 40]
      });

      route.to.marker = L.marker([route.to.lat, route.to.lng], {icon: redMarker})
      .bindTooltip(this.getEndMarkerTooltip(route), {})
      .addTo(this.map);
    }

    getRouteTooltip = (route) => {
      return null;
    }

    getStartMarkerTooltip = (route) => {
      return '<ul class="tooltip-content">' +
        '<li>'+route.from.name+'</li>'+
        '<li>Pick: '+route.startDate.getHours()+':'+route.startDate.getMinutes()+'</li>'+
        '<li>Dist: '+route.distance+' Km</li>'+
        '<li>Rev: '+route.revenue+' €</li>'+
        '</ul>';
    }

    getEndMarkerTooltip = (route) => {
      return '<ul class="tooltip-content">' +
        '<li>'+route.to.name+'</li>'+
        '<li>Rel: '+route.endDate.getHours()+':'+route.endDate.getMinutes()+'</li>'+
        '<li>Dist: '+route.distance+' Km</li>'+
        '<li>Rev: '+route.revenue+' €</li>'+
        '</ul>';
    }

    componentDidMount() {
      //Rewrite prototype for Icon
      L.Marker.prototype.options.icon = L.icon({
        iconRetinaUrl,
        iconUrl,
        shadowUrl,
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41]
      });

      /*
      var mapboxLayer = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/streets-v9/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZmxhdmlldHRvIiwiYSI6ImNpdndidGxicDAwMGsyeXFjcnVucjY3bXIifQ.FFGUhmc3K9UqyOJbU2jKpA', {
  			attribution: 'Mapbox Map',
  			maxZoom: 18
  		});
      */

      var osmLayer = L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  			//attribution: 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
  			maxZoom: 18
  		});


  		var gmapLayer = L.tileLayer('http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',{
  			//attribution: '© Google Maps 2017',
  			maxZoom: 20,
  			subdomains:['mt0','mt1','mt2','mt3']
  		});


  		var baseMaps = {
        "Google Satellite": gmapLayer,
        //"Mapbox Street": mapboxLayer,
        "Open Street View": osmLayer

  		};

  		this.map = L.map('map', {
        center: [39.542938, -97.367541],
  			zoom: 4
  		});

  		gmapLayer.addTo(this.map);
      //mapboxLayer.addTo(this.map);
      osmLayer.addTo(this.map);



  		L.control.layers(baseMaps).addTo(this.map);

  	}



    componentWillUpdate() {

        /* Cancellazione della route a video al cambio di un dato qualsiasi */
      //console.log('Cancellazione della route attuale...');
      if (this.props.route.polyline) {
        //console.log('Eseguo la cancellazione...');
        this.props.route.polyline.remove();
        this.props.route.polyline = null;
      }
    }


    addRouteToMap = (route) => {
      //console.log('Aggiorno la path');
      //console.log(route.vectorPath);

      /*
      if (route.vectorPath) {
        route.vectorPath.map((vpath) => {
          vpath.reverse();
          return null;
        });
      }
      */

      var polyline = L.polyline(route.vectorPath, {color: 'red', className:'map-selected-polyline'})
      .bindTooltip('Info on the route...')
      .addTo(this.map);

      this.props.route.polyline = polyline;
    }

    componentDidUpdate = () => {
      //console.log('update');
      if (this.props.route.from.marker != null) {
        this.props.route.from.marker.remove();
      }

      if (this.props.route.to.marker != null) {
        this.props.route.to.marker.remove();
      }

      if (this.props.route.polyline != null) {
        this.props.route.polyline.remove();
        this.props.route.polyline = null;
      }

      if (this.props.route.from.lat > 0) {
          this.addStartMarkerToMap(this.props.route);
      }

      if (this.props.route.to.lat > 0) {
          this.addEndMarkerToMap(this.props.route);
      }

      if(this.props.route.vectorPath.length > 0) {
        this.addRouteToMap(this.props.route);
      }

      if ((this.props.route.from.lat != 0) && (this.props.route.from.lng != 0) && (this.props.route.to.lat != 0) && (this.props.route.to.lng != 0)) {
        this.map.fitBounds([[this.props.route.from.lat, this.props.route.from.lng], [this.props.route.to.lat, this.props.route.to.lng]]);
      }


    };


    render() {
        return(
          <span>
            <div  id="map"></div>
          </span>
        );
    }
}
;



// WEBPACK FOOTER //
// ./src/components/MapCreatorPanel.js